import { render, staticRenderFns } from "./UpdateMyAccount.vue?vue&type=template&id=4634f505&scoped=true&"
import script from "./UpdateMyAccount.vue?vue&type=script&lang=js&"
export * from "./UpdateMyAccount.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMyAccount.vue?vue&type=style&index=0&id=4634f505&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634f505",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VTextField})
